import {
	Alert,
	Box,
	Button,
	Card,
	CardContent,
	TextField,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useLogin, useNotify } from "react-admin";
import { TurnstileProvider, useTurnstile } from "@/hooks/useTurnstile";

const CustomLoginForm = () => {
	const [loading, setLoading] = useState(false);
	const login = useLogin();
	const notify = useNotify();
	const { isReady, getCaptchaHeaders, reset } = useTurnstile();

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);

		const formData = new FormData(event.currentTarget);
		const email = formData.get("email") as string;
		const password = formData.get("password") as string;

		try {
			const captchaHeaders = getCaptchaHeaders();
			await login({ username: email, password, captchaHeaders });
		} catch (error) {
			notify(error instanceof Error ? error.message : "Login failed", {
				type: "error",
			});
			reset();
		} finally {
			setLoading(false);
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
				<TextField
					label="Email"
					name="email"
					type="email"
					autoComplete="email"
					required
					fullWidth
				/>
				<TextField
					label="Password"
					name="password"
					type="password"
					autoComplete="current-password"
					required
					fullWidth
				/>
				{!isReady && (
					<Alert severity="info" sx={{ mt: 1 }}>
						Preparing security verification...
					</Alert>
				)}
				<Button
					type="submit"
					variant="contained"
					color="primary"
					disabled={loading || !isReady}
					fullWidth
					sx={{ mt: 2 }}
				>
					{loading ? "Signing in..." : "Sign In"}
				</Button>
			</Box>
		</form>
	);
};

export const LoginPage = () => (
	<TurnstileProvider>
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100vh",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "background.default",
			}}
		>
			<Card sx={{ minWidth: 400, maxWidth: 500 }}>
				<CardContent>
					<Box sx={{ mb: 3, textAlign: "center" }}>
						<Typography variant="h4" component="h1" gutterBottom>
							BitEasy Admin
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Sign in with your admin account
						</Typography>
					</Box>
					<CustomLoginForm />
				</CardContent>
			</Card>
		</Box>
	</TurnstileProvider>
);
